/**
 *
 * Helper Class with some useful utilities
 *
 */

const $      = require( 'jQuery' );

module.exports = (function(){

  var utl = {};

  utl.camelize  = function(text) {
    return text.replace(/^([A-Z])|[\s-_]+(\w)/g, function (match, p1, p2, offset) {
      if (p2) return p2.toUpperCase();
      return p1.toLowerCase();
    });
  };

  utl.slugify = function(text){

    return text.replace(/[^A-Z0-9]/ig, '-').toLowerCase();

  };

  // Append Meta tags dynamically
  // Usage: utl.setMT('property', 'og:title', 'Title for Facebook');
  // https://stackoverflow.com/a/5653131/5681525
  
  utl.setMT = function(metaName, name, value) {
    var t = 'meta['+metaName+'="'+name+'"]';
    var mt = $(t);
    if (mt.length === 0) {
      t = '<meta '+metaName+'="'+name+'" />';
      mt = $(t).appendTo('head');
    }
    mt.attr('content', value);
  }

  return utl;

})();
